import styled from "@emotion/styled"
import { Flex, Box } from "reflexbox"

import { queries } from "../../utils/mediaqueries.js"

import theme from "../../theme"

export const MedicalReviewWrapper = styled(Flex)`
  margin: 16px 0 0 0;
  ${queries.medium`
    margin: 50px 0 0 0;
  `}
`

export const DoctorWrapper = styled(Box)`
  padding-left: 15px;
  a {
    text-decoration: none;
    font-family: ${theme.font.mono} !important;
    color: ${theme.color.green};
    border-bottom: 1px solid ${theme.color.green};
    padding-bottom: 3px;
    font-size: 14px;
    line-height: 19px;
  }
  span {
    display: block;
    margin-top: 5px;
  }
`

export const Reviewed = styled.p`
  font-family: ${theme.font.book} !important;
  font-size: 12px;
  font-weight: 300;
  color: rgb(45, 45, 45);
  margin-top: 10%;
  margin-bottom: 0;
  line-height: 21px;
  ${queries.medium`
    font-size: 14px;
  `}
`

export const DoctorThumbnail = styled(Box)`
  img {
    width: auto;
    padding-top: 17px;
  }
`

export const HeadingWrapper = styled.div`
  padding: 0 25px !important;
`

export const AuthorInfoWrapper = styled(Flex)`
  flex-direction: column;
`

export const AuthorInfoBox = styled(Box)``

export const SectionHeaderText = styled.h2`
  color: rgb(45, 45, 45);
  /* margin: 15px 0 -10px 0; */
  margin: 0;
  font-family: ${theme.font.demi} !important;
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
`

export const ParagraphText = styled.div`
  /* padding-top: 15px; */
  p {
    padding-top: 15px;
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    margin: 0;
  }
`

export const HomepageExcerpt = styled.h2`
  font-family: ${theme.font.regular} !important;
`

export const BlogPostsWrapper = styled.div``

export const PostContainer = styled(Flex)`
  flex-direction: column;
  ${queries.medium`
    flex-direction: row;
    flex-wrap: wrap;
  `}
`

export const PostWrapper = styled.div`
  flex: 0 0 calc(33.3% - 17px);
  margin: 25px 0;
  position: relative;
  a {
    text-decoration: none;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 0 0 31%;
  }
`

export const PostTileImage = styled.div`
  cursor: pointer;
  img {
    width: 100%;
  }
`

export const PostTileTitle = styled.div`
  h2,
  h3 {
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }
  a {
    text-decoration: none;
    color: #000;
  }
  ${queries.medium`
    h2,
    h3 {
      font-size: 20px;
      line-height: 26px;
    }
  `}
`

export const CategoryReadTime = styled(Flex)`
  padding-bottom: 8px;
  line-height: 21px;
  p {
    margin: 0;
    font-family: ${theme.font.book} !important;
    font-size: 12px;
    font-weight: 300;
    color: rgb(115, 114, 115);
    text-transform: uppercase;
  }
  span {
    transform: translateY(2px);
    margin-left: 10px;
    width: 10px;
    border-left: 1px solid rgb(115, 114, 115);
    height: 15px;
  }
`

export const FeaturedPostWrapper = styled(Flex)`
  flex-direction: column;
  position: relative;
  ${queries.medium`
    img {
      height: 520px;
    }
  `}
`

export const WidePostWrapper = styled(Flex)`
  flex-direction: column;
  display: none;
  ${queries.medium`
    display: flex;
    margin-top: 25px;
    margin-bottom: 25px;
  `}
`

export const ImageHolder = styled(Box)`
  img {
    width: 100%;
  }
  .desktop-featured-image-tag {
    display: none;
  }
  ${queries.medium`
    .desktop-featured-image-tag {
      display: block;
    }
    .mobile-featured-image-tag {
      display: none;
    }
  `}
`

export const InfoHolder = styled(Box)`
  height: 171px;
  background: rgb(243, 241, 233);
  text-align: center;
  transform: translateY(-5px);
  a {
    text-decoration: none;
  }
  h1,
  h2,
  h3 {
    color: rgb(45, 45, 45);
    font-family: ${theme.font.light} !important;
    font-size: 24px;
    font-weight: 300;
    line-height: 32px;
    text-align: left;
    padding: 0 24px;
    width: 100%;
  }
  ${queries.medium`
    h1,
    h2,
    h3 {
      text-align: left;
      padding: 0 70px;
      color: rgb(45, 45, 45);
      font-size: 32px;
      font-weight: 300;
      line-height: 43px;
    }
  `}
`

export const FeaturedCategoryReadTime = styled(Flex)`
  padding: 0 24px;
  justify-content: start;
  p {
    margin: 0;
    font-family: ${theme.font.book} !important;
    font-size: 12px;
    font-weight: 300;
    color: rgb(45, 45, 45);
    text-transform: uppercase;
    line-height: 19px;
  }
  span {
    margin-left: 10px;
    width: 10px;
    border-left: 1px solid rgb(115, 114, 115);
    height: 15px;
  }
  ${queries.medium`
    padding: 0 24%;
    justify-content: start;
  `}
`

export const SiteLinkTitle = styled.div`
  background: rgb(31, 99, 96);
  padding: 16px;
  transform: translateY(-5px);
  h2,
  h3 {
    margin: 0;
    font-family: ${theme.font.book} !important;
    font-size: 17px;
    font-weight: 300;
    line-height: 24px;
    color: ${theme.color.white};
  }
  a {
    text-decoration: none;
    color: #000;
  }
  p {
    display: inline-block;
    padding-bottom: 5px;
    margin-top: 10px;
    font-family: ${theme.font.mono} !important;
    font-size: 16px;
    font-weight: 300;
    color: ${theme.color.white};
    border-bottom: 1px solid ${theme.color.white};
  }
  ${queries.medium`
    h2,
    h3 {
      font-size: 20px;
      line-height: 26px;
    }
    a {
      font-size: 14px;
      line-height: 19px;
    }
  `}
`

export const EmailSignupText = styled.div`
  h2 {
    margin-top: 0;
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    padding-right: 35px;
    color: rgb(45, 45, 45);
    font-family: ${theme.font.book} !important;
  }
  ${queries.medium`
    h2 {
      font-size: 20px !important;
      line-height: 26px;
    }
  `}
`

export const EmailFormWrapper = styled.div`
  padding: 24px 32px;
  margin: 25px 0;
  border: 2px solid rgb(31, 99, 96);
  flex: 0 0 33.333333%;
  .form-wrapper {
    height: 42px;
    border: 1px solid #454545;
    background: #fff;
    margin-top: 1em;
  }
`

// email input element
export const EmailSignupTextBox = styled.input`
  color: #454545;
  padding: 0 10px;
  letter-spacing: 0.01em;
  line-height: 40px;
  width: 100%;
  height: 100%;
  outline: none;
  font-size: 14px;
  &:focus {
    outline: 0;
    height: 100%;
  }
  &::placeholder {
    color: ${theme.color.lightGray};
    opacity: 1;
  }
`

// Arrow button in subscription form
export const ArrowButton = styled.button`
  height: 40px;
  width: 100%;
  padding: 0;
  line-height: inherit;
  border: none;
  background: none;
  &:before {
    content: "\\e906";
    font-family: "icomoon" !important;
    font-weight: normal;
    font-size: 14px;
    color: #1f6360;
  }
  &:focus {
    outline: 0;
  }
`

export const StyledLinkWrapper = styled.div`
  border: 2px solid rgb(31, 99, 96);
  a {
    text-decoration: none;
    color: #000;
  }
  h3 {
    display: inline-block;
    padding-bottom: 5px;
    margin-top: 10px;
    font-family: ${theme.font.mono} !important;
    font-size: 16px;
    font-weight: 300;
    color: ${theme.color.green};
    border-bottom: 1px solid ${theme.color.green};
  }
  h2 {
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    line-height: 21px;
    margin-bottom: 0;
  }
`

export const StyledCTAWrapper = styled.div`
  border: 2px solid rgb(31, 99, 96);
  a {
    text-decoration: none;
    color: #000;
  }
  h3 {
    display: inline-block;
    padding-bottom: 5px;
    margin-top: 10px;
    font-family: ${theme.font.mono} !important;
    font-size: 16px;
    font-weight: 300;
    color: ${theme.color.green};
    border-bottom: 1px solid ${theme.color.green};
  }
  h2 {
    font-family: ${theme.font.demi} !important;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
  }
  p {
    font-family: ${theme.font.book} !important;
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 5px;
  }
`

export const PostBodyImageWrapper = styled.div`
  img,
  video {
    width: 100%;
  }
  a {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  .image-label {
    text-align: left;
    font-family: ${theme.font.book} !important;
    font-weight: 300;
    color: rgb(115, 114, 115);
    font-style: italic;
    font-size: 14px;
  }
  .giorgios-signature {
    width: 150px;
  }
`

export const LinkButton = styled.a`
  width: 80%;
  display: block;
  margin: 0 auto;
  border-width: 1px;
  &:hover,
  &:focus {
    font-family: ${theme.font.book} !important;
    font-size: 14px;
    font-weight: 300;
    text-transform: uppercase;
    text-decoration: none;
  }
  &:active {
    background: ${theme.color.white};
    color: ${theme.color.green};
  }
  ${queries.medium`
    width: 100%;
    max-width: 385px;
    padding-left: 0;
    padding-right: 0;
  `}
`

export const LinkButtonButton = styled.button`
  width: 80%;
  display: block;
  margin: 0 auto;
  border-width: 1px;
  &:hover,
  &:focus {
    font-family: ${theme.font.book} !important;
    font-size: 14px;
    font-weight: 300;
    text-transform: uppercase;
    text-decoration: none;
  }
  &:active {
    background: ${theme.color.white};
    color: ${theme.color.green};
  }
  ${queries.medium`
    width: 100%;
    max-width: 200px;
    padding-left: 0;
    padding-right: 0;
  `}
`

export const NewsletterBox = styled(Box)`
  ${queries.medium`
    width: 50%;
  `}
`

export const NewsletterInner = styled(Flex)`
  flex-direction: column;
  ${queries.medium`
    flex-direction: row;
  `}
`

export const NewsletterLabelBox = styled(Box)`
  p {
    color: #2d2d2d;
  }
`

export const NewsletterInputBox = styled(Box)``

export const NewsletterInput = styled.input`
  color: #454545;
  padding: 0 45px 0 10px;
  letter-spacing: 0.01em;
  line-height: 40px;
  width: 122%;
  height: 48px;
  outline: none;
  font-size: 16px;
  border: 1px solid rgb(69, 69, 69);
  &:focus {
    outline: 0;
    height: 100%;
  }
  &::placeholder {
    color: rgb(115, 114, 115);
    opacity: 1;
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
  }
  &.error {
    border: 1px solid rgb(179, 0, 0) !important;
  }
`

export const LogoBox = styled(Box)`
  ${queries.medium`
    width: 50%;
  `}
`

export const LogoInner = styled.div`
  display: flex;
  flex-direction: column;
  ${queries.medium`
    display: block;
    width: 265px;
  `}
`

export const SocialLogoBox = styled(Box)`
  width: 100%;
  display: flex;
  margin-top: 45px;
  .logo-holder {
    width: 50%;
  }
  .nutra-logo {
    height: 13px;
    width: 104px;
  }
  .social-icon {
    height: 22px;
    width: 22px;
  }
  .social-icon-holder {
    width: 50%;
    display: flex;
  }
  .icon-item {
    flex: 33.3%;
    cursor: pointer;
  }
  ${queries.medium`
    margin-top: 0;
  `}
`

export const FooterNotes = styled(Box)`
  margin-top: 8px;
  p {
    font-family: ${theme.font.demi} !important;
    font-size: 10px;
    font-weight: 500;
    margin: 0;
    color: #22202f;
  }
  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`

export const ChannelWrapper = styled(Box)`
  width: 100%;
  text-align: center;
  cursor: pointer;
  h1,
  h2,
  p {
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    padding-bottom: 5px;
    @media (min-width: 768px) and (max-width: 1100px) {
      font-size: 14px;
    }
  }
  a {
    text-decoration: none;
  }
`

export const ShopButtonWrapper = styled(Box)`
  width: 100%;
  @media (min-width: 768px) {
    text-align: center;
  }
  img {
    color: ${theme.color.green};
    width: 54px;
    transform: translate(15px, 10px);
    @media (min-width: 768px) and (max-width: 849px) {
      width: 45px;
      transform: translate(0, 13px);
    }
    @media (min-width: 850px) {
      transform: translate(0, 14px);
    }
  }
  a {
    cursor: pointer;
    text-decoration: none;
  }
`

export const AltShopButtonWrapper = styled(Box)`
  h1 {
    font-family: ${theme.font.book} !important;
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    margin-top: 0;
  }
  a {
    cursor: pointer;
    text-decoration: none;
    color: ${theme.color.white};
    span {
      font-family: ${theme.font.book};
      font-weight: 300;
    }
  }
`

export const PostSlicesWrapper = styled.div`
  position: relative;
  ${queries.medium`
    width: 569px;
    margin-left: auto;
    margin-right: auto; 
  `}
`

export const HomepageSliceWrapper = styled.div`
  color: rgb(45, 45, 45);
`

export const BlockQuote = styled.blockquote`
  border-left: 2px solid rgb(115, 114, 115);
  padding-left: 20px;
  font-family: ${theme.font.book} !important;
  font-style: italic;
  font-size: 20px;
  font-weight: 300;
  line-height: 27px;
  color: rgb(115, 114, 115);
  margin-right: 0;
  span,
  p {
    padding: 0;
    margin: 0;
  }
`

export const SiteLinkImage = styled.div`
  img {
    width: 100%;
  }
`

export const EmailContentWrapper = styled.div`
  padding-top: 25%;
  min-height: 325px;
`

export const BlankTileWrapper = styled.div`
  padding: 25% 0 0 15%;
  height: 325px;
  h2,
  h3 {
    font-family: ${theme.font.book} !important;
    font-size: 20px;
    font-weight: 300;
    padding-right: 25px;
  }
  p {
    color: rgb(45, 45, 45);
  }
`

export const AltPostWrapper = styled.div`
  flex: 0 0 31%;
  margin: 25px 0;
  ${queries.medium`
    display: none;
  `}
`

export const HeaderWrapper = styled.div`
  &.mousedown {
    *:focus {
      outline: none;
    }
  }
  [target~="_blank"] {
    &:after {
      content: "(Opens in new tab)";
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }
  }
`

export const MobileNavWrapper = styled.div`
  height: 100%;
  position: relative;
`

export const MobileChannels = styled.div`
  @media (min-height: 472px) {
    padding-top: 35px;
  }
`

export const MobileChannelWrapper = styled(Flex)`
  a {
    text-decoration: none;
    color: #fff;
    display: inline-block;
    width: 100%;
    padding: 16px 64px 16px 0;
    margin-left: -32px;

    img {
      padding-left: 32px;
    }
  }
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  > div {
    flex-basis: 98%;
  }
  .mobile-channel-arrow {
    margin-left: auto;
    flex-basis: 2%;
  }
  h2 {
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    padding-left: 32px;
  }
`

export const NavSocialIcons = styled(Flex)`
  width: 80%;
  flex-wrap: wrap;
  position: absolute;
  bottom: 0;
  @media (max-height: 495px) {
    position: relative;
    padding-top: 20px;
  }
`

export const SocialIcon = styled(Box)`
  flex: 0 0 33%;
  padding-bottom: 10px;
`

export const TwoPhotoWrapper = styled(Flex)`
  flex-direction: row;
  a {
    width: 100%;
  }
  .image-label {
    a {
      text-decoration: none;
    }
  }
`

export const LeftPhotoBox = styled(Box)`
  height: auto;
  width: 100%;
  img {
    width: 100%;
    height: 290px;
  }
  padding-right: 5px;
  ${queries.medium`
    // width: 50%;
    padding-right: 12px;
    img {
      width: 100%;
      height: 341px;
    }
  `}
`

export const RightPhotoBox = styled(Box)`
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: 290px;
  }
  padding-left: 5px;
  ${queries.medium`
    // width: 50%;
    padding-left: 12px;
    img {
      width: 100%;
      height: 341px;
    }
  `}
`

export const SideBarWrapper = styled.div`
  display: none;
  right: -50%;
  position: absolute;
  width: 243px;
  @media (min-width: 1124px) {
    display: block;
  }
`

export const References = styled.div`
  * {
    color: rgba(67, 86, 82, 1) !important;
    font-size: 12px !important;
    margin: 0 !important;
    line-height: 18px !important;
  }
`

export const TopSectionWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1280px;
  padding: 50px 25px 15px 25px;
  margin-left: auto;
  margin-right: auto;
  ${queries.medium`
    width: 100%;
    max-width: 1280px;
    padding: 50px 50px 15px 50px;
    margin-left: auto;
    margin-right: auto;
  `}
`

export const StickyIconsWrapper = styled.div`
  display: none;
  ${queries.medium`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 10px;
    bottom: 15%;
    position: fixed;
    z-index: 999;
    img {
      padding-bottom: 10px;
      cursor: pointer;
    }
    a {
      img {
        cursor: pointer;
      }
    }
    @media(min-width: 1345px){
      left: 3%;
      @media(min-width: 1530px){
        left: 8%;
        @media(min-width: 1700px){
          left: 12%;
          @media(min-width: 1950px){
            left: 17%;
          }
        }
      }
    }
  `}
`

export const ExpandPlus = styled(Box)`
  font-family: ${theme.font.book} !important;
  font-size: 16px;
  font-weight: 300;
`

export const LoaderWrapper = styled.p`
  text-align: center;
  margin-top: 1%;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: none;
  }
`

export const SearchBarWrapper = styled.form`
  display: flex;
  position: relative;
  width: 0;
  float: right;
  min-width: 26px;
  overflow: hidden;
  -webkit-transition: width 0.3s;
  -moz-transition: width 0.3s;
  -o-transition: width 0.3s;
  transition: width 0.3s;
  &.expanded {
    width: 100%;
    border-bottom: 1px solid rgb(69, 69, 69);
  }
  .search-icon {
    cursor: pointer;
  }
  .searchbar-input {
    border: 0;
    background: rgb(248, 248, 245);
    width: 100%;
    // needed to prevent zoom on ios
    font-size: 16px;
    ${queries.medium`
      width: 215px;
      &.expanded-input {
        width: 240px;
      }
    `}
    &:focus {
      outline: none;
    }
  }
  .search-x {
    height: 10px;
    width: 10px;
    transform: translateY(9px);
    cursor: pointer;
  }
  input::placeholder {
    color: rgb(115, 114, 115);
    font-family: ${theme.font.book} !important;
    font-size: 14px;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: none;
  }
`

export const AnswerText = styled.h4`
  display: inline-block;
  vertical-align: top;
  color: rgb(115, 114, 115);
  font-family: ${theme.font.book} !important;
  font-weight: 300;
  font-size: 10px;
  line-height: 13px;
  margin: 0;
`

export const HiddenCheckInput = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &:checked + div {
    .check-icon {
      display: inline-block;
      margin: 0 auto;
    }
  }
`

export const VisibleCheckInput = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  margin-right: ${theme.spacing.small};
  border: 1px solid ${theme.color.black};
  background: ${theme.color.white};
  text-align: center;
  .check-icon {
    display: none;
  }
`

export const Label = styled.label`
  cursor: pointer;
`

export const FilterWrapper = styled(Flex)`
  flex-direction: column;
  margin-left: auto !important;
  margin-right: auto !important;
`

export const TitleWrapper = styled(Box)`
  h2 {
    font-family: ${theme.font.light} !important;
    font-size: 28px;
    font-weight: 300;
    color: rgb(45, 45, 45);
    margin-bottom: 15px;
  }
`

export const ResultsSummary = styled(Box)`
  p {
    color: rgb(45, 45, 45);
    font-family: ${theme.font.book} !important;
    font-size: 16px;
    font-weight: 300;
    margin-top: 0;
  }
`

export const OptionsWrapper = styled(Flex)`
  ${queries.medium`
    justify-content: flex-end;
    padding-right: 35px;
  `}
`

export const SelectDropdownWrapper = styled(Box)`
  width: 128px;
  > div {
    > div {
      width: 102%;
      margin-right: 20px;
      border: 1px solid rgb(69, 69, 69) !important;
      border-radius: 0;
      box-shadow: none;
      &:focus {
        outline: 1px auto -webkit-focus-ring-color;
      }
      > div {
        padding: 5px 5px 5px 17px;
        + div {
          span {
            display: none;
          }
          div {
            svg {
              width: 17px;
              height: 17px;
            }
          }
        }
        > div:first-of-type {
          color: rgb(115, 114, 115);
          font-family: ${theme.font.book} !important;
          font-size: 14px;
          font-weight: 300;
        }
      }
      + div {
        margin: 0;
        border: 1px solid #ccc;
        border-bottom: none;
        > div {
          padding: 0;
          > div {
            height: 45px;
            border-bottom: 1px solid #ccc;
            font-family: ${theme.font.book} !important;
            font-size: 14px;
            font-weight: 300;
            padding: 13px 10px 8px 18px;
            color: rgb(45, 45, 45) !important;
            &.is-selected {
              background: rgb(243, 243, 243);
            }
            &:focus {
              background: rgb(243, 243, 243);
            }
          }
        }
      }
    }
  }
`

export const DropdownWrapper = styled(Box)`
  width: 128px;
  .Dropdown-control {
    height: 48px;
    width: 128px;
    padding: 14px 52px 8px 17px;
    margin-right: 20px;
    border: 1px solid rgb(69, 69, 69);
  }
  .Dropdown-placeholder {
    color: rgb(115, 114, 115);
    font-family: ${theme.font.book} !important;
    font-size: 14px;
    font-weight: 300;
  }
  .Dropdown-arrow-wrapper {
    transform: translate(82px, -20px);
    img {
      height: 7px;
      width: 11px;
    }
    .arrow-open {
      img {
        transform: rotate(180deg);
      }
    }
  }
  .Dropdown-option {
    height: 45px;
    border-bottom: 1px solid #ccc;
    font-family: ${theme.font.book} !important;
    font-size: 14px;
    font-weight: 300;
    padding: 12px 10px 8px 10px;
    color: rgb(45, 45, 45);
    &.is-selected {
      background: rgb(243, 243, 243);
    }
  }
`

export const TagsWrapper = styled(Box)``

export const TagFilterWrapper = styled.div`
  position: relative;
  cursor: pointer;
`

export const FilterBox = styled(Flex)`
  height: 48px;
  width: 80px;
  border-radius: 8px;
  border: 1px solid rgb(69, 69, 69);
  background: #fff;
  .filter-box-inner {
    position: relative;
    p {
      position: absolute;
      left: 30px;
      bottom: 3px;
      color: rgb(115, 114, 115);
      font-family: ${theme.font.book} !important;
      font-size: 14px;
      font-weight: 300;
      margin-top: 0;
    }
    img {
      position: absolute;
      width: 10px;
      height: 10px;
      top: 16px;
      left: 15px;
    }
  }
`

export const TagNumber = styled.div`
  position: absolute;
  height: 20px;
  width: 20px;
  bottom: 37px;
  left: 67px;
  background: #000;
  border-radius: 50%;
  z-index: 1;
  p {
    color: #fff;
    margin-top: 0;
    padding-left: 7px;
    font-size: 10px;
    padding-top: 3px;
  }
`

export const ExpandWrapper = styled(Flex)`
  padding-top: 20px;
`

export const TagsContainer = styled(Flex)`
  flex-flow: row wrap;
`

export const DesktopTagsContainer = styled(Flex)`
  justify-content: space-between;
`

export const TagSection = styled(Box)`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 50%;
  padding-right: 35px;
  h3 {
    font-family: ${theme.font.demi} !important;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
  }
`

export const DesktopTagSection = styled(Box)`
  flex-grow: 1;
  h3 {
    font-family: ${theme.font.demi} !important;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
  }
`

export const SingleTag = styled.div`
  padding-top: 10px;
`

export const TagLabel = styled.p``

export const Disclaimer = styled(Box)`
  font-family: ${theme.font.book} !important;
  font-size: 10px;
  font-weight: 300;
  padding-top: 16px;
  ${queries.medium`
    .mobile-breaker {
      display: none;
    }
  `}
`

export const SectionLabel = styled(Box)`
  font-family: ${theme.font.book} !important;
  font-size: 12px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.86px;
`

export const InfoBox = styled.input`
  height: 48px;
  &:focus {
    outline: none;
  }
  &.error {
    border: 1px solid rgb(179, 0, 0);
  }
`

export const TestimonialSlide = styled(Flex)`
  flex-direction: column;
  background: #76b9af;
  padding: 50px;
  height: 310px;
  p {
    color: #fff;
    text-align: center;
  }
`

export const DisclaimerTextWrapper = styled.div`
  p {
    font-family: ${theme.font.book} !important;
    font-size: 12px;
    font-weight: 300;
    color: rgb(115, 114, 115);
    line-height: 19px;
  }
`

export const ErrorTextWrapper = styled.div`
  p {
    color: rgb(224, 43, 39);
    font-family: ${theme.font.book} !important;
    font-size: 12px;
    margin-bottom: 0;
  }
`

export const EmailSuccessWrapper = styled.div`
  p {
    font-family: ${theme.font.book} !important;
    font-size: 12px;
    margin-bottom: 0;
  }
  &.isFooter {
    ${queries.medium`
      padding-left: 24px;
  `}
  }
`

export const MobileOptions = styled.div`
  ${queries.medium`
    display: none;
  `}
`

export const DesktopOptions = styled.div`
  display: none;
  ${queries.medium`
    display: flex;
  `}
`

export const BeforeAfterSliderContainer = styled.div`
  .desktop-before-after-slider-custom {
    display: none;
  }
  ${queries.medium`
    .desktop-before-after-slider-custom {
      display: block;
    }
    .mobile-before-after-slider-custom {
      display: none;
    }
  `}
`

export const ShopProductsWrapper = styled.div`
  .desktop-wrapper {
    display: none;
  }
  .slick-prev,
  .slick-next {
    z-index: 9;
    top: calc(50% - 24px);
  }
  .slick-prev {
    &:before {
      color: #000 !important;
    }
    left: 0;
  }
  .slick-next {
    &:before {
      color: #000 !important;
    }
    right: 0;
  }
  ${queries.medium`
    .mobile-wrapper {
      display: none;
    }
    .desktop-wrapper {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  `}
`

export const MobileShopProductWrapper = styled(Box)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  padding: 0;
  img {
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }
  a {
    text-decoration: none;
    font-family: ${theme.font.book} !important;
    font-weight: bold;
    white-space: nowrap;
    color: #000;
    text-align: center;
  }
`

export const ShopProductWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33.3%;
  padding: 32px 8px;
  margin: 0 -8px;
  img {
    max-width: 100%;
  }
  a {
    margin-top: 30px;
    text-decoration: none;
    font-family: ${theme.font.book} !important;
    font-weight: bold;
    color: #000;
    text-align: center;
  }
`

export const TextOnlyTile = styled.div`
  background: rgb(31, 99, 96);
  height: 100%;
  min-height: 325px;
  h2 {
    color: ${theme.color.white};
    font-size: 18px;
    font-family: ${theme.font.book};
    font-weight: 300;
    line-height: 24px;
  }
  a {
    text-decoration: none;
    color: #000;
  }
  h3 {
    display: inline-block;
    padding-bottom: 5px;
    margin-top: 10px;
    font-family: ${theme.font.mono} !important;
    font-size: 14px;
    font-weight: 300;
    color: ${theme.color.white};
    border-bottom: 1px solid ${theme.color.white};
  }
  p {
    color: ${theme.color.white};
    font-size: 14px;
    font-family: ${theme.font.book};
    font-weight: 300;
    line-height: 21px;
  }
  ${queries.medium`
    h2 {
      font-size: 20px;
      line-height: 26px;
    }
  `}
`

export const CenteredWrapper = styled.div`
  padding: 24px;
  width: 100%;
  ${queries.medium`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  `}
`

export const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  ${queries.medium`
    flex-direction: row;
  `}
`

export const AuthorName = styled.h1`
  text-transform: uppercase;
  font-family: ${theme.font.book} !important;
  font-size: 24px;
  margin-bottom: 5px;
`

export const AuthorBio = styled.p`
  font-family: ${theme.font.book} !important;
  font-size: 14px;
`

export const AuthorImageWrapper = styled.div`
  img {
    width: 200px;
    height: auto;
  }
`

export const DoctorImageWrapper = styled.div`
  padding-left: 0;
  padding-top: 0;
  img {
    width: 200px;
    height: auto;
  }
`
